import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { API_URL } from "../../../config";

const AssignAccessoryModal = ({
  addAccessoryModal,
  setAddAccessoryModal,
  distributorId,
  setSuccessModal,
  setSuccessMessage,
  godevicelist,
}) => {
  const [accessoryQty, setAccessoryQty] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleAssignAccessory = async () => {
    setError("");

    if (!accessoryQty) {
      return setError("Please enter sensor quantity");
    }

    if (isNaN(accessoryQty) || Number(accessoryQty) <= 0) {
      return setError("Enter valid positive number");
    }

    try {
      setLoading(true);

      const token = localStorage.getItem("accessToken");

      const res = await fetch(`${API_URL}/sensor-txn`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({
          distributor_id: distributorId,
          available: Number(accessoryQty),
        }),
      });

      const data = await res.json();

      if (!data.status) {
        throw new Error(data.message || "Something went wrong");
      }

      setAccessoryQty("");
      setAddAccessoryModal(false);
      setSuccessMessage("Sensors assigned successfully");
      godevicelist();
      setSuccessModal(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={addAccessoryModal}
      toggle={() => setAddAccessoryModal(false)}
      className="connect-box"
      centered={true}
    >
      <ModalHeader className="text-white" toggle={() => setAddAccessoryModal(false)}>
        <span className="ml-1 roititle text-white">Assign Sensors</span>
      </ModalHeader>

      <ModalBody>
        <div className="modal-paragrph">
          <div className="col-lg-12">
            <div className="row">
              <div className="form-group col-lg-12 no-padding">
                <label className="control-label mb-0">
                  Number of sensors*
                </label>

                <input
                  type="number"
                  value={accessoryQty}
                  onChange={(e) => setAccessoryQty(e.target.value)}
                  className="client-input"
                  placeholder="Enter sensor quantity"
                />

                {error && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {error}
                  </div>
                )}
              </div>
            </div>

            <div className="py-1 text-center" style={{ display: "flex", justifyContent: "center" }}>
              <button
                type="button"
                onClick={handleAssignAccessory}
                className="btn-primary m-0"
                disabled={loading}
              >
                {loading ? "Assigning..." : "Assign"}
                {loading && <div id="loader"></div>}
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AssignAccessoryModal;
